export default __webpack_public_path__ + "static/media/connect-big-commerce1.1b45af53.jpeg";